import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { cloneDeep } from 'lodash';
import { FormGroup, Label, Col, Row } from 'reactstrap';
import { IconPlusCircleOutline, IconMinusCircleOutline } from '@sfx/icons';
import Select from '../../../Basic/Select';
import UserOption, { filterOption as userFilterOption } from './userOption.component';
import SubscriptionOption, { SubscriptionValue } from '../common/subscriptionOption.component';
export var UserGroup = function UserGroup(_ref) {
  var initOneUserInfo = _ref.initOneUserInfo,
      userInfoList = _ref.userInfoList,
      roleToSubscriptions = _ref.roleToSubscriptions,
      mode = _ref.mode,
      updateUserInfoList = _ref.updateUserInfoList,
      translate = _ref.translate;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var _useState3 = useState(userInfoList),
      _useState4 = _slicedToArray(_useState3, 2),
      userInfoData = _useState4[0],
      setUserInfoData = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      canAdd = _useState6[0],
      setCanAdd = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      hasSubscription = _useState8[0],
      setHasSubscription = _useState8[1];

  var addUser = function addUser() {
    setUserInfoData([].concat(_toConsumableArray(userInfoList), [_objectSpread(_objectSpread({}, initOneUserInfo), {}, {
      _id: count + 1
    })]));
    setCount(count + 1);
  };

  var deleteUser = function deleteUser(_id) {
    setUserInfoData(userInfoList.filter(function (i) {
      return i._id !== _id;
    }));
  };

  var _onChange = function onChange(value, _id, type) {
    var userInfo = cloneDeep(userInfoList.find(function (i) {
      return i._id === _id;
    }));

    if (userInfo && userInfo[type]) {
      userInfo[type].value = value;

      if (type === 'solutionRole' && hasSubscription) {
        userInfo.subscription.value = '';
      }

      setUserInfoData(userInfoList.map(function (i) {
        return i._id === _id ? _objectSpread(_objectSpread({}, i), userInfo) : i;
      }));
    }
  };

  useEffect(function () {
    updateUserInfoList(userInfoData);
  }, [userInfoData, updateUserInfoList]);
  useEffect(function () {
    setHasSubscription(!initOneUserInfo.subscription.isDisabled);
  }, [initOneUserInfo.subscription]);
  useEffect(function () {
    setCanAdd(!initOneUserInfo.email.isLoading);
  }, [initOneUserInfo.email.isLoading]);

  var getEmailOption = function getEmailOption() {
    var EmailOption = initOneUserInfo.email.options;
    var currentList = userInfoData.map(function (i) {
      return i.email.value;
    });
    return EmailOption.filter(function (i) {
      return !currentList.find(function (n) {
        return n.id === i.id;
      });
    });
  };

  var getSubscriptionOption = function getSubscriptionOption(solutionRole) {
    var currentList = userInfoList.map(function (i) {
      return i.subscription.value || {
        id: ''
      };
    });
    var result = cloneDeep(roleToSubscriptions);
    Object.keys(result).forEach(function (i) {
      result[i] = roleToSubscriptions[i].filter(function (s) {
        return !currentList.find(function (n) {
          return s.id === n.id;
        });
      });
    });
    var currentSolutionId = solutionRole.value && solutionRole.value.id;
    var subscriptionList = currentSolutionId ? result[currentSolutionId] : [];
    var initSubscription = initOneUserInfo.subscription,
        initSolutionRole = initOneUserInfo.solutionRole;
    var initSolutionRoleId = initSolutionRole.value && initSolutionRole.value.id;

    if (mode === 'edit' && subscriptionList && initSubscription && initSolutionRoleId && initSolutionRoleId === currentSolutionId) {
      subscriptionList.push(initSubscription.value);
    }

    return subscriptionList;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, userInfoList.length > 0 && /*#__PURE__*/React.createElement(Row, {
    className: cx('sm-label', 'solution-row')
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Label, null, translate('SFxAccountSettingsSolutionModalEmailLabel'))), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Label, null, translate('SFxAccountSettingsSolutionModalSolutionRoleLabel'))), hasSubscription && /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Label, null, translate('SFxAccountSettingsSolutionModalSubscriptionLabel')))), userInfoList.map(function (_ref2) {
    var _id = _ref2._id,
        subscription = _ref2.subscription,
        email = _ref2.email,
        solutionRole = _ref2.solutionRole;
    return /*#__PURE__*/React.createElement(Row, {
      className: "solution-row",
      key: _id
    }, /*#__PURE__*/React.createElement(Col, {
      sm: "4"
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      className: "down-sm-label"
    }, translate('SFxAccountSettingsSolutionModalEmailLabel')), /*#__PURE__*/React.createElement(Select, {
      isLoading: initOneUserInfo && initOneUserInfo.email && initOneUserInfo.email.isLoading,
      isDisabled: mode === 'edit',
      value: email.value,
      options: getEmailOption(),
      renderOption: function renderOption(data) {
        return {
          value: data.id,
          label: data.email
        };
      },
      filterOption: userFilterOption,
      components: {
        Option: UserOption
      },
      onChange: function onChange(value) {
        return _onChange(value, _id, 'email');
      }
    }))), /*#__PURE__*/React.createElement(Col, {
      sm: "4"
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      className: "down-sm-label"
    }, translate('SFxAccountSettingsSolutionModalSolutionRoleLabel')), /*#__PURE__*/React.createElement(Select, {
      isLoading: solutionRole.isLoading,
      isMulti: false,
      value: solutionRole.value,
      options: solutionRole.options,
      renderOption: function renderOption(data) {
        return {
          label: data.name,
          value: data.id
        };
      },
      onChange: function onChange(value) {
        return _onChange(value, _id, 'solutionRole');
      }
    }))), hasSubscription && /*#__PURE__*/React.createElement(Col, {
      sm: "4"
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      className: "down-sm-label"
    }, translate('SFxAccountSettingsSolutionModalSubscriptionLabel')), /*#__PURE__*/React.createElement(Select, {
      value: subscription.value,
      options: getSubscriptionOption(solutionRole),
      renderOption: function renderOption(data) {
        return {
          label: data.name,
          value: data.id
        };
      },
      components: {
        Option: SubscriptionOption,
        ValueContainer: SubscriptionValue
      },
      onChange: function onChange(value) {
        return _onChange(value, _id, 'subscription');
      },
      isDisabled: subscription.isDisabled
    }))), mode === 'add' && canAdd && /*#__PURE__*/React.createElement("span", {
      className: cx('delete-icon', 'icon', {
        'delete-icon-two-cell': !hasSubscription
      }),
      onClick: function onClick() {
        return deleteUser(_id);
      }
    }, /*#__PURE__*/React.createElement(IconMinusCircleOutline, {
      size: "20"
    })));
  }), mode === 'add' && canAdd && /*#__PURE__*/React.createElement(Row, {
    className: "solution-row"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon",
    onClick: addUser
  }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
    size: "18"
  }), "\xA0", translate('SFxAccountSettingsSolutionModalAssignUserButtonText')))));
};